import {httpCall, httpMethod} from "../../service";

export const loadOrders = (appDbPrefix, before, after, search, page) => {
    return httpCall( httpMethod.GET, `/${ appDbPrefix }/orders/${ page }?after=${ after }&before=${ before }&search=${ search }` )
}

export const loadMagnitudeOrders = (appDbPrefix, before, after, search, page) => {
    return httpCall( httpMethod.GET, `/${ appDbPrefix }/magnitude/orders/${ page }?after=${ after }&before=${ before }&search=${ search }` )
}

export const loadOperatorOrders = (appDbPrefix, operatorName, operatorId, before, after, search, page) => {
    return httpCall( httpMethod.GET, `/${ appDbPrefix }/operator-orders/${ operatorName }/${ operatorId }/${ page }?after=${ after }&before=${ before }&search=${ search }` )
}


export const loadLastVersion = (appDbPrefix) => httpCall( httpMethod.GET, `/${ appDbPrefix }/version` )



export const sendImageData = (appDbPrefix, companyName, codArt, mimeType, content, imageCode) => {
    return httpCall(httpMethod.POST, `/${appDbPrefix}/company/${ companyName }/article/${ codArt }/img/${ imageCode }`, { mimeType: mimeType, content: content });
};
